import { Lock } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import {
  hasGoogleBusinessLocation,
  selectProviders,
} from '../../../reducers/reputationManagementReducer'

const SelectLocationReminder = ({ onClick = () => {}, hasGoogleBusinessLocation, providers }) => {
  const { t } = useTranslation(['organisation'])
  const googleProviderAvailable = providers.some((p) => p.provider === 'google' && p.available)
  if (hasGoogleBusinessLocation || !googleProviderAvailable) return null

  return (
    <div className="reputation-management-reminder__container">
      <div className="reputation-management-reminder__content">
        <Lock size={24} weight="fill" className="reputation-management-reminder__icon" />
        <div className="reputation-management-reminder__title">
          {t('organisation:reputationManagement.selectLocationReminder.title')}
        </div>
        <div className="reputation-management-reminder__subtitle">
          {t('organisation:reputationManagement.selectLocationReminder.subtitle')}
        </div>
        <button className="button button-gray" onClick={onClick}>
          {t('organisation:reputationManagement.selectLocationReminder.button')}
        </button>
      </div>
    </div>
  )
}

SelectLocationReminder.propTypes = {
  hasGoogleBusinessLocation: PropTypes.bool,
  onClick: PropTypes.func,
}

export default connect(
  (state) => ({
    hasGoogleBusinessLocation: hasGoogleBusinessLocation(state),
    providers: selectProviders(state),
  }),
  null,
)(SelectLocationReminder)
